export const complementaryListColumn = [
    {
        Header: 'Id',
        accessor: 'id',
    },
    {
        Header: 'Room Name',
        accessor: 'roomName',
    },
    {
        Header: 'Complementary',
        accessor: 'complementary',
    },
    {
        Header: 'Complementary Rate',
        accessor: 'complementaryRate',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
]

export const complementaryListTableData = [
    {
        "id": "1101",
        "roomName": "Family Room",
        "complementary": "Online",
        "complementaryRate":"5%"
    },
    {
        "id": "1102",
        "roomName": "Deluxe Room",
        "complementary": "Online",
        "complementaryRate":"15%"
    },
    {
        "id": "1103",
        "roomName": "Standard Room",
        "complementary": "Online",
        "complementaryRate":"10%"
    },
    {
        "id": "1104",
        "roomName": "Single Room",
        "complementary": "Online",
        "complementaryRate":"12%"
    },
    {
        "id": "1105",
        "roomName": "Executive Suite",
        "complementary": "Offline",
        "complementaryRate":"14%"
    },
    {
        "id": "1106",
        "roomName": "Presidential Suite",
        "complementary": "Online",
        "complementaryRate":"16%"
    },
    {
        "id": "1107",
        "roomName": "Double Room",
        "complementary": "Offline",
        "complementaryRate":"18%"
    },
    {
        "id": "1108",
        "roomName": "Family Suite",
        "complementary": "Offline",
        "complementaryRate":"20%"
    },
]